<template>
  <div class="commodity-group-view">
    <mt-index-list>
      <mt-index-section v-for="(items, indexs) in brandList" :key="indexs" :index="items.letter">
        <li class="commodity-item border-bottom-1px" v-for="item in items.brandData" :key="item.brandId" @click="toCommodityPage(item)">
          <img :src="item.brandLogoImg" onerror="this.src='//static.yunjiweidian.com/qnUpload/frontend/logo/icon-bitmap1.png'">
          <div class="commodity-content">
            <span class="commodity-title">{{item.brandName}}</span>
            <div class="comodity-des">
              <p class="des-stock">
                <span class="gray">在售商品</span>
                <span>{{item.onlineItemNum}}</span>
              </p>
              <p class="des-new">  
                <span class="gray">本周上新</span>
                <span>{{item.weekOnlineNum}}</span>
              </p>
            </div>
          </div>
        </li>        
      </mt-index-section>
      <div :class="+appCont===7?'heighMiniPro':'heighNormal'"></div>
    </mt-index-list>
  </div>
</template>

<script>
import Vue from 'vue';
import { IndexList, IndexSection } from 'mint-ui';
import { createNamespacedHelpers } from 'vuex'
import YunJi from '@/assets/js/YunJi'
const { mapState, mapActions } = createNamespacedHelpers('brandList')

Vue.component(IndexList.name, IndexList);
Vue.component(IndexSection.name, IndexSection);
export default {
  data() {
    return {
      shopId: YunJi.getUrlParams('shopId'),
      appCont: YunJi.getUrlParams('appCont')
    }
  },
  computed: {
    ...mapState({
      brandList: state => state.brandList
    })
  },
  created() {
    this.queryBrandList()
  },
  methods: {
    ...mapActions(['queryBrandList']),
    // 跳转到品牌馆页面
    toCommodityPage(data) {
      let url = `/yjbuyer/brand-index?brandId=${data.brandId}&appCont=0`
      if (this.shopId) url = `${url}&shopId=${this.shopId}`
      location.href = `//${globalConfig.buyerBasePath}${url}`
    }
  }
};
</script>

<style lang="less" scoped>
.commodity-group-view{
  display: flex;
  /deep/ .mint-indexlist{
    background-color: #F2F2F2;
    .mint-indexlist-content{
      margin: 0 !important;
    }
    .heighNormal{
      height:1.68rem;
    }
    .heighMiniPro{
      height:3.36rem;
    }
    .mint-indexsection-index{
      padding: 0 0.24rem;
      height: 0.4rem;
      line-height: 0.4rem;
      background: none;
    }
    .mint-indexlist-nav{
      border: none;
      background: none;
    }
    .mint-indexsection>ul{
      padding: 0 0.24rem;
      background-color: #ffffff;
    }
  }
  .commodity-item{
    display: flex;
    align-items: center;
    height: 1.68rem;
    width: 100%;
    overflow: hidden;
    img{
      width: 1.2rem;
      height: 1.2rem;
      margin-right: 0.16rem;
    }
    .commodity-content{
      .commodity-title{
        display: block;
        margin-bottom: 0.2rem;
      }
      .comodity-des{
        display: flex;
        p{
          font-size: 0.24rem;
          color: #333333;
          span{
            display: inline-block;
            line-height: 0.4rem;
          }
          .gray{
            margin-right: 0.08rem;
            color: #999999;
          }
          &.des-stock{
            margin-right: 0.24rem;
          }
        }
      }
    }
  }
}
</style>